import { createUseStyles } from 'react-jss';
import { Breakpoints } from '@/lib/breakpoints';
import { SITE_GUTTER } from '@/constants/layout';
import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { TextColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles(
  {
    main: {
      minHeight: '100vh',
      backgroundColor: BackgroundColors.base,
      color: TextColors.base,
      paddingLeft: SITE_GUTTER.mobile,
      paddingRight: SITE_GUTTER.mobile,
      [Breakpoints.SM]: { paddingLeft: SITE_GUTTER.desktop, paddingRight: SITE_GUTTER.desktop },
    },
  },
  { name: 'category-page-layout' },
);

export default useStyles;
